module.exports = __webpack_public_path__ + "static/img/partner_low.d886973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner_low.jpg
// module id = A5yK
// module chunks = 1